module.exports = __webpack_public_path__ + "img/74ne.9c255a2a.svg";